import { Component } from '@angular/core';
import { AgFns } from 'app/shared/ag-fns';
import { UniAgFns } from '@/shared/uni-ag-fns';
import { Account } from 'app/model/entities/entity-model';

import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { EntityFinderDialog, EntityFinderParams } from 'app/shared/entity-finder.dialog';
import { DbQueryService } from 'app/shared/db-query.service';

export interface AccountFinderParams extends EntityFinderParams {
  shouldShowReissueAccountsOnly?: boolean;
}

@Component({
  template: EntityFinderDialog.HTML,
  host: { hostID: crypto.randomUUID().toString() },
  standalone: false,
})
export class AccountFinderDialogComponent extends EntityFinderDialog<Account, AccountFinderParams> {
  shouldShowReissueAccountsOnly: boolean;

  constructor(
    ref: DynamicDialogRef,
    config: DynamicDialogConfig<AccountFinderParams>,
    public dbQueryService: DbQueryService,
  ) {
    super(ref, config);
    this.shouldShowReissueAccountsOnly = this.params.shouldShowReissueAccountsOnly ?? false;
    const title = `Select Account ${this.shouldShowReissueAccountsOnly ? ' - Account-Owned Inventory Management Only' : ''}`;

    Object.assign(this.config, {
      header: title,
      // width: '800px;',
      // height: '530px',
      rowModelType: 'serverSide',
    });
  }

  override getColDefsAndSortModel() {
    const colDefs = [
      {
        headerName: 'Name',
        field: 'accountName',
        filter: 'agTextColumnFilter',
      },
      {
        ...UniAgFns.getActiveStatusColDef('activeStatus.name'),
        headerName: 'Active Status',
        filter: 'agTextColumnFilter',
      },
      {
        headerName: 'Start Date',
        field: 'startDate',
        filter: 'agDateColumnFilter',
      },
      {
        headerName: 'Invoice and Manifest Email',
        field: 'invoiceEmail',
        filter: 'agNumberColumnFilter',
      },
    ];

    const sortModel = [{ colId: 'accountName', sort: 'asc' as const }];
    return [colDefs, sortModel] as const;
  }

  override async initDatasource() {
    let q = this.dbQueryService.createAccountQuery(this.shouldShowReissueAccountsOnly);
    const ds = AgFns.buildDatasource(() => q);
    return ds;
  }

  // async ok() {

  //   if (this.selectedAccount.activeStatusId == ActiveStatusEnum.Inactive) {
  //     // const ynRes = await this.dialogWrapperService.askYesNo('Inactive Account', 'This account is inactive - Do you want to continue anyway?');
  //     const ok = await this.dialogWrapperService.askIfOk('Inactive Account', 'This account is inactive - Do you want to continue anyway?');

  // }
}
